import styled from '@emotion/styled'
import darken from 'polished/lib/color/darken'

import { palette, typography } from 'main/ui'

export const Container = styled.div`
  color: ${palette.almostBlack};
  font-family: ${typography.fontFamily.ui};
  font-size: ${typography.fontSize.text};
  font-weight: ${typography.fontWeight.regular};
  line-height: 24px;
  overflow-wrap: anywhere;

  * a {
    color: ${palette.skyBlue2};
    cursor: pointer;
    text-decoration: none;

    &:hover {
      color: ${darken(0.1, palette.skyBlue2)};
    }
  }

  * h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  strong {
    font-weight: ${typography.fontWeight.bold};
  }

  p:empty {
    display: none;
  }
`
